import { Route, Switch, useParams } from 'react-router-dom';
import Loader from '__components/Kizen/Loader';
import { useMCPServerDetailPage } from './context';

export const MCPServerDetail = () => {
  const { mcpServerId } = useParams<{ mcpServerId: string }>();
  const ctx = useMCPServerDetailPage();
  const { isLoading } = ctx.query;
  const { routePatterns } = ctx;

  return (
    <Loader loading={isLoading}>
      <Switch>
        {routePatterns.map(({ component: Component, path, exact }) =>
          Component ? (
            <Route
              key={path}
              path={path}
              exact={exact}
              // React Router v5 doesn't remount on a param-only change, so key
              // by mcpServerId to reset each tab's local state.
              render={() => <Component key={mcpServerId} />}
            />
          ) : null
        )}
      </Switch>
    </Loader>
  );
};
